// extracted by mini-css-extract-plugin
export default {"switch":"toggle-module--switch--cere8","slider":"toggle-module--slider--vbwbZ","round":"toggle-module--round--wdoRF"};